import React from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

export interface IBreadcrumbLink {
  label: string;
  path?: string;
  component?: React.ElementType;
  [key: string]: unknown;
}
interface IProps {
  items: IBreadcrumbLink[];
}

export default function Breadcrumbs({ items }: IProps): React.ReactElement {
  return (
    <Breadcrumb separator={<FontAwesomeIcon className="utility-icon" icon={faChevronRight} />}>
      {items.map(renderBreadcrumbItem)}
    </Breadcrumb>
  );
}

const renderBreadcrumbItem = (
  { label, path, component = 'a', ...otherProps }: IBreadcrumbLink,
  index: number,
): React.ReactElement => {
  const isDefault = component === 'a';

  const breadcrumbItemLink = isDefault ? (
    <DefaultBreadcrumbLink label={label} path={path || ''} {...otherProps} />
  ) : (
    <BreadcrumbLink as={component} {...otherProps}>
      {label}
    </BreadcrumbLink>
  );
  return <BreadcrumbItem key={index}>{breadcrumbItemLink}</BreadcrumbItem>;
};

interface IDefaultBreadcrumbLink {
  label: string;
  path: string;
  [key: string]: unknown;
}
const DefaultBreadcrumbLink = ({ path, label, ...otherProps }: IDefaultBreadcrumbLink): React.ReactElement => (
  <BreadcrumbLink href={path} {...otherProps}>
    {label}
  </BreadcrumbLink>
);
